export default __webpack_public_path__ + "static/media/superStar.89bcdd24.png";